/**
 * A React component that sets the Material UI X Pro license key for the application.
 * This component should be rendered once at the root level to enable licensed features.
 *
 * @remarks
 * The license key is set using `LicenseInfo.setLicenseKey` from `@mui/x-license`.
 *
 * @returns null - This component does not render any UI.
 * 
 * @link https://mui.com/x/introduction/licensing/
 */
'use client';
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE_KEY);



export default function MuiXLicense() {
  return null;
}